import type { FC } from "react";
import { Banner, ClickableText, Icon, Text } from "../../primitives";

export type MissingCompanyAddressBannerProps = {
	companyNames: string[];
	/** What the missing address blocks, e.g. "send the indemnity agreement". */
	blockedAction: string;
	onAddAddress: () => void;
	testId?: string;
};

/** "A", "A and B", "A, B and C". */
export const formatCompanyNames = (names: string[]): string =>
	names.length <= 1
		? (names[0] ?? "")
		: `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;

/** Explains why an action is blocked on a company address and links to where the agent adds it. */
export const MissingCompanyAddressBanner: FC<MissingCompanyAddressBannerProps> = ({
	companyNames,
	blockedAction,
	onAddAddress,
	testId = "missing-company-address-banner",
}) => (
	<Banner tone="notification" data-testid={testId}>
		<Banner.Leading>
			<Icon type="exclamation-triangle" color="warning" size="small" />
		</Banner.Leading>
		<Banner.Content className="flex flex-col gap-2">
			<Text type="body-strong" color="primary">
				Add an address for {formatCompanyNames(companyNames)}
			</Text>
			<Text type="body" color="secondary">
				You can't {blockedAction} until every company has an address.{" "}
				<ClickableText color="link" onClick={onAddAddress} data-testid={`${testId}-action`}>
					Add it on the Details tab
				</ClickableText>
			</Text>
		</Banner.Content>
	</Banner>
);
